export default "__VITE_ASSET__Bw8t5XB8__"